import React from 'react';
import exact from 'prop-types-exact';
import PropTypes from 'prop-types';

const Placeholder = ({
    minHeight = '200px',
    height,
    width = '100%',
    margin = '0 0 0 0',
    className = '',
}) => {
    const style = {
        minHeight,
        height,
        width,
        margin,
    };

    return (
        <div className={`loaderBase ${className}`} style={style}>
            <div className="Placeholder">
                <div className="fly" />
            </div>
        </div>
    );
};

Placeholder.propTypes = exact({
    minHeight: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
    margin: PropTypes.string,
    className: PropTypes.string,
});

export default Placeholder;
